import { BasicGrid, Text, DateRange } from '@104ha/base-ui';
import { PageGrid } from '../../../../../../client/src/components/Grids';
import React from 'react';

// const today = new Date();

function getDayStr(date: Date) {
	const dd = String(date.getDate()).padStart(2, '0');
	const mm = String(date.getMonth() + 1).padStart(2, '0');
	const yyyy = date.getFullYear();
	return yyyy + '-' + mm + '-' + dd;
}

function getLastWeeksDate() {
	const now = new Date();

	return new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
}

export class Grid extends PageGrid/*<
	{
		openBrowseDialog?: (rowData: any) => any;
	},
	{ confirm: any }
>*/ {
	static defaultProps = {
		...PageGrid.defaultProps,
		api: '/api/manage/log/find',
		colWidths: [40, 300, '*', '*', 180, 200],
		fetch: false,
		basicCriteria: {
			apiName: {
				label: 'API名稱',
				input: (
					<Text
						{...{
							width: 120,
							validate: { max: 50 },
						}}
					/>
				),
				fireOnEditing: true,
			},
			kw: {
				label: '登入帳號或IP',
				input: (
					<Text
						{...{
							width: 120,
							validate: { max: 50 },
						}}
					/>
				),
				fireOnEditing: true,
			},
			workDate: {
				label: '查詢範圍',
				input: (
					<DateRange
						{...{
							width: 290,
							placeholder: ['查詢範圍(起)', '查詢範圍(訖)'],
							initValue: [getDayStr(new Date()), getDayStr(new Date())],
							validate: {
								required: true,
							},
						}}
					/>
				),
			},
		},
	};

	renderGridHeader() {
		const { TH } = this;
		return (
			<tr>
				<TH.seq />
				<TH.sortable sortKey="apiName">API名稱</TH.sortable>
				<TH.sortable sortKey="userAccount">API登入帳號</TH.sortable>
				<TH.sortable sortKey="userName">帳號名稱</TH.sortable>
				<TH.sortable sortKey="ip">登入IP</TH.sortable>
				<TH.sortable sortKey="logDatetime">Token到期時間</TH.sortable>
			</tr>
		);
	}

	renderGridBody(data: any, idx: number) {
		const { TD } = this;
		const { apiName, userAccount, userName, logDatetime, ip } = data;

		return (
			<>
				<TD.seq idx={idx} />
				<td>
					<a
						href="/"
						onClick={(e) => {
							e.preventDefault();
							this.props.openBrowseDialog?.({
								...data,
								idx,
							});
						}}
					>
						{apiName}
					</a>
				</td>
				<td>{userAccount}</td>
				<td>{userName}</td>
				<td>{ip}</td>
				<td>{logDatetime}</td>
			</>
		);
	}
}
